import { Controller } from "@hotwired/stimulus"
import { ensureDatepicker } from "../lib/datepicker_loader"

// Выбор месяца через bootstrap-datepicker (режим только месяцы).
// jQuery и плагин грузятся лениво (общий загрузчик lib/datepicker_loader) —
// только на страницах с month-picker.
// При выборе переходит на тот же раздел за выбранный месяц, сохраняя
// текущий фильтр по ФИО и типу лица.
export default class extends Controller {
  static values = { url: String }

  async connect() {
    const $ = await ensureDatepicker()
    if (!this.element.isConnected) return // отключился, пока грузили

    $(this.element)
      .datepicker({
        format: "MM yyyy",
        startView: "months",
        minViewMode: "months",
        autoclose: true,
        language: "ru",
        orientation: "bottom auto"
      })
      .on("changeDate", (e) => this.navigate(e.date))
  }

  disconnect() {
    if (window.jQuery) {
      const el = window.jQuery(this.element)
      if (el.data("datepicker")) el.datepicker("destroy")
    }
  }

  navigate(date) {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("year", date.getFullYear())
    url.searchParams.set("month", date.getMonth() + 1)

    const q = document.querySelector("input[name='q']")
    if (q && q.value) url.searchParams.set("q", q.value)
    const type = document.querySelector("input[name='type']:checked")
    if (type) url.searchParams.set("type", type.value)

    window.Turbo ? Turbo.visit(url.toString()) : (window.location = url.toString())
  }
}
